/* global mobileMenu */

import ToggleableComponent from "./ToggleableComponent";

export default class HeaderSearch {
  constructor() {
    this.setup();
  }

  setup () {

    this.searchFormToggle = new ToggleableComponent(
      document.querySelector('.region-header .search-icon'),
      document.querySelector('.region-header .search-form-wrapper'),
      true,
    );

    this.searchFormToggle.toggleCallback = function (toggled) {
      if (toggled) {
        if (typeof mobileMenu !== 'undefined' && typeof mobileMenu.deactivate !== 'undefined') {
          mobileMenu.deactivate();
        }

        // Focus search input.
        this.component.querySelector('input').focus();
      }
    }
  }
}
